import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { Button, Modal } from 'react-bootstrap';
import { casefoldersSelectOptions, limitSelectOptions } from '../formData';
import { SearchPDFsField, CasesField } from '../fields';
import '../AdvancedSearch.less';

const AdvancedFilterModal = ({ onSave, show, onClose, filter }) => (
  <Modal
    show={show}
    onHide={onClose}
    // backdrop="static"
    // keyboard={false}
    dialogClassName="advanced-search-modal"
  >
    <div>
      <Form
        onSubmit={onSave}
        initialValues={filter}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>Advanced Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <SearchPDFsField
                  limitSelectOptions={limitSelectOptions}
                  disabled={['cases', 'petitions'].includes(filter.tab)}
                />
                <CasesField casefoldersSelectOptions={casefoldersSelectOptions} />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={onClose}>Cancel</Button>
              <Button bsStyle="primary" type="submit">
                Apply
              </Button>
            </Modal.Footer>
          </form>
        )}
      />
    </div>
  </Modal>
);

AdvancedFilterModal.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  filter: PropTypes.object.isRequired,
};

AdvancedFilterModal.defaultProps = {
  show: false,
};

export default AdvancedFilterModal;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/AdvancedFilterModal.jsx